export default __webpack_public_path__ + "static/media/M52.6a612f45.svg";